// frontend/src/modules/email/pages/EmailSettingsPage.tsx
import * as React from 'react';
import { PageHeader } from '../../../design-system/components/PageHeader';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../../components/ui/tabs';

import { ProviderTab } from './ProviderTab';
import { TemplatesTab } from './TemplatesTab';
import { TestSendTab } from './TestSendTab';
import { LogTab } from './LogTab';
import { DeliverabilityTab } from './DeliverabilityTab';
import { CampaignsTab } from './CampaignsTab';

export function EmailSettingsPage() {
  const [tab, setTab] = React.useState<'campaigns' | 'provider' | 'templates' | 'test' | 'log' | 'deliverability'>('campaigns');

  return (
    <div>
      <PageHeader
        eyebrow="Comms / Email"
        title="Email"
        description="Campaigns, provider, templates, test sends, and the full delivery log — all in one place."
      />
      <div className="px-6 sm:px-8 lg:px-10 pb-12">
        <Tabs value={tab} onValueChange={(v) => setTab(v as any)}>
          <TabsList className="bg-muted/50 ring-1 ring-border/40 rounded-full p-1 h-10 inline-flex">
            <TabsTrigger value="campaigns" className="rounded-full px-4 h-8 text-[12.5px] font-semibold data-[state=active]:bg-foreground data-[state=active]:text-background">Campaigns</TabsTrigger>
            <TabsTrigger value="provider"  className="rounded-full px-4 h-8 text-[12.5px] font-semibold data-[state=active]:bg-foreground data-[state=active]:text-background">Provider</TabsTrigger>
            <TabsTrigger value="templates" className="rounded-full px-4 h-8 text-[12.5px] font-semibold data-[state=active]:bg-foreground data-[state=active]:text-background">Templates</TabsTrigger>
            <TabsTrigger value="test"      className="rounded-full px-4 h-8 text-[12.5px] font-semibold data-[state=active]:bg-foreground data-[state=active]:text-background">Test send</TabsTrigger>
            <TabsTrigger value="log"       className="rounded-full px-4 h-8 text-[12.5px] font-semibold data-[state=active]:bg-foreground data-[state=active]:text-background">Log</TabsTrigger>
            <TabsTrigger value="deliverability" className="rounded-full px-4 h-8 text-[12.5px] font-semibold data-[state=active]:bg-foreground data-[state=active]:text-background">Deliverability</TabsTrigger>
          </TabsList>
          <TabsContent value="campaigns" className="pt-6"><CampaignsTab /></TabsContent>
          <TabsContent value="provider"  className="pt-6"><ProviderTab /></TabsContent>
          <TabsContent value="templates" className="pt-6"><TemplatesTab /></TabsContent>
          <TabsContent value="test"      className="pt-6"><TestSendTab /></TabsContent>
          <TabsContent value="log"       className="pt-6"><LogTab /></TabsContent>
          <TabsContent value="deliverability" className="pt-6"><DeliverabilityTab /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
